import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';

@Injectable()
export class CenterSpecializationService {

  constructor(private _http: HttpClient) {
  }

  getAllList(page) {
    return this._http.post<any>('api/a/dict/center/specialization/all/list', page);
  }

  getBy(filter: any) {
    return this._http.post<any[]>(`api/a/dict/center/specialization/all/filter`, filter);
  }

  save(dto) {
    return this._http.post<any>('api/a/dict/center/specialization/save', dto);
  }

  getById(id) {
    return this._http.get<any>('api/a/dict/center/specialization/' + id);
  }

  getGsLegalEntitySpecializations(collegeId, applicationId, professionCode, isNew) {
    return this._http.get<any>('api/a/dict/center/specialization/gs/legal-entities/' + collegeId + '/' + applicationId
      + '/' + professionCode + '/' + isNew);
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/shared/services/center-specialization.service.ts